import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'

import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { Provider } from 'react-redux'
import moment from 'moment'
import 'moment-timezone'

import rootReducer from './reducers'
import thunk from 'redux-thunk'
import 'moment/locale/it'
import Layout from './components/Bone/Layout'
import AuthLayout from './components/Bone/AuthLayout'
import Home from './components/Home'
import Login from './components/Login'
import Attendances from './components/Attendances'
import Balance from './components/Balance'
import Courses from './components/Courses'
import Members from './components/Members'
import Receipts from './components/Receipts'
import Club from './components/Club'
import Instructors from './components/Instructors'
import Dashboard from './components/Dashboard'
import Howitworks from './components/Howitworks'
import Notes from './components/Notes'

moment.tz.setDefault('Europe/London')

const store = createStore(rootReducer, composeWithDevTools(
  applyMiddleware(thunk)
))
// store.subscribe(() => console.log('store', store.getState()));

class App extends React.Component {
  render () {
    return (
      <Provider store={store}>
        <BrowserRouter>
          <Route render={ ({ location }) => (
            <Layout location={ location }>
              <Switch location={ location }>
                <Route exact path='/' component={Home} />
                <Route exact path='/accedi' component={Login} />
                <Route exact path='/come-funziona' component={Howitworks} />
                <AuthLayout>
                  <Route exact path="/dashboard" component={Dashboard} />
                  <Route exact path='/presenze' component={Attendances} />
                  <Route exact path='/ricevute' component={Receipts} />
                  <Route exact path='/anagrafiche' component={Members} />
                  <Route exact path='/corsi' component={Courses} />
                  <Route exact path='/bilancio' component={Balance} />
                  <Route exact path='/associazione' component={Club} />
                  <Route exact path='/istruttori' component={Instructors} />
                  <Route exact path='/note' component={Notes} />
                </AuthLayout>
              </Switch>
            </Layout>
          )} />
        </BrowserRouter>
      </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js